(function () {
    function moviePosterInformation($interval, $sce, $timeout, $rootScope) {
        return {
            restrict: 'E',
            template: '<div ng-include="getTemplateUrl()"></div>',
            scope: {
                movie: "=",
                filteredShowtimes: '=totalShowings',
                ticketsOnSale: "=",
                movieFormatType: "=",
                alignText: "@",
                showImage: "@",
                cappedWidth: "@",
                cardType: "@",
                disabledShowtimesDir: "=disabledshowtimes",
                disabledShowtimesRangeDir: "=disableddaterange",
                notSellableShowtimes: "=notsellableshowtimes"
            },
            link: function (scope, element, attrs) {
                scope.customClasses = "";

                if ('cardType' in attrs) {
                    scope.cardType = attrs['alignText'];
                }

                if (scope.cappedWidth) {
                    scope.customClasses += "capped-width";
                }

                if ('alignText' in attrs) {
                    scope.alignment = 'movie-text-align-' + attrs['alignText'];
                    scope.customClasses += " " + scope.alignment;
                }

                scope.showtimeFormatfilter = function (showingsFormat) {
                    var showformat = _.get(showingsFormat, '[0].FormatType');

                    if (_.isEmpty(scope.movieFormatType)) {
                        return true;
                    }

                    var imax_keyword = "IMAX";
                    if ((scope.movieFormatType.indexOf(imax_keyword) > -1) && (showformat.indexOf(imax_keyword) > -1)) {
                        return true;
                    } else {
                        return showformat === scope.movieFormatType;
                    }
                }

                scope.sellableOnline = function (filmid) {
                    if (scope.notSellableShowtimes && typeof scope.notSellableShowtimes === 'object') {
                        if (scope.notSellableShowtimes.hasOwnProperty(filmid)) {
                            var message = scope.notSellableShowtimes[filmid];
                            return message;
                        }
                    }
                    return 'true';
                }

                scope.showNotSellableModal = function (filmid) {
                    var message = scope.sellableOnline(filmid);
                    if (message !== 'true') {
                        //console.log('Broadcasting modal message for filmid:', filmid);

                        // Broadcast to $rootScope so the modal can pick it up regardless of scope isolation
                        $rootScope.$broadcast('showNotSellableModal', {
                            message: message,
                            trustedHtml: $sce.trustAsHtml(message)
                        });

                        // Small delay to ensure broadcast is processed
                        $timeout(function () {
                            $('#notSellableModal').modal('show');
                        }, 100);
                    }
                }

                // Listen for modal events at this directive's scope level
                scope.$on('showNotSellableModal', function (event, data) {
                    console.log('Received modal broadcast:', data);
                    scope.modalMessageRaw = data.message;
                    scope.modalMessage = data.trustedHtml;
                });

                scope.titleText = function (show) {
                    var eventNameAppend = _.get(show, 'EventName') ? ' | ' + _.get(show, 'EventName') : "";

                    if (!scope.ticketsOnSale) {
                        return 'Tickets coming soon' + eventNameAppend;
                    }
                    if (show.ShowSoldOut) {
                        return 'Tickets are sold out' + eventNameAppend;
                    }
                    if (show.TicketsSellingFast) {
                        return 'Almost sold out' + eventNameAppend;
                    }
                    if (show.cancelMessage) {
                        return show.cancelMessage + eventNameAppend;
                    }
                    if (show.EventName) {
                        return show.EventName;
                    }
                }

                var disabledCinemas = {};
                scope.isDisabledShowtimeTime = function (show, showtimeRanges) {
                    if (_.has(disabledCinemas, show.CinemaID)) {
                        if (_.isEmpty(disabledCinemas[show.CinemaID])) {
                            return false;
                        } else {
                            var showtime = moment(show.StartTime);

                            if (showtime.isBetween(disabledCinemas[show.CinemaID].Start, disabledCinemas[show.CinemaID].End)) {
                                show.cancelMessage = disabledCinemas[show.CinemaID].Reason;
                                return true;
                            } else {
                                return false;
                            }
                        }
                    } else {
                        var foundCinema = _.find(showtimeRanges, { 'CinemaId': show.CinemaID });
                        if (foundCinema) {
                            disabledCinemas[show.CinemaID] = {
                                Start: moment(foundCinema.Start),
                                End: moment(foundCinema.End),
                                Reason: foundCinema.Reason,
                            }

                            var showtime = moment(show.StartTime);
                            if (showtime.isBetween(disabledCinemas[show.CinemaID].Start, disabledCinemas[show.CinemaID].End)) {
                                show.cancelMessage = disabledCinemas[show.CinemaID].Reason;
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            disabledCinemas[show.CinemaID] = null;
                            return false;
                        }
                    }
                }

                scope.isDisabledShowtime2 = function (id, ids) {
                    return (ids.indexOf(id) > -1);
                }

                scope.getTemplateUrl = function () {
                    var url = "";

                    switch (scope.cardType) {
                        case 'movie-detail':
                            url = '/Assets/Templates/tmpl.moviePosterInformationMovieDetail.html';
                            break;
                        case 'location-detail':
                            url = '/Assets/Templates/tmpl.moviePosterInformationLocationDetail.html';
                            break;
                        case 'home-page':
                            url = '/Assets/Templates/tmpl.moviePosterInformation.html';
                            break;
                        default:
                            url = '/Assets/Templates/tmpl.moviePosterInformation.html';
                            break;
                    }
                    return url;
                };

                scope.counter = 0;
                var toggleToolTips = function () {
                    $('[data-toggle="tooltip"]').tooltip();
                };

                var intervalPromise = $interval(toggleToolTips, 1000);

                scope.$on('$destroy', function () {
                    $interval.cancel(intervalPromise);
                });
            }
        };
    }
    moviePosterInformation.$inject = ['$interval', '$sce', '$timeout', '$rootScope'];
    angular
        .module("cstudioApp.directives")
        .directive("moviePosterInformation", moviePosterInformation);
})();